<template>
  <div :class="type">
    <v-container class="fixed-width">
      <v-row class="spacing6">
        <v-col md="6" class="pa-6" :class="isMobile ? 'text-center' : 'text-left'">
          <title-main :align="isTablet ? 'center' : 'left'" primary="Frequently" secondary="Answered Questions" />
          <p
            class="text use-text-subtitle2"
            :class="[isMobile ? 'text-center' : 'text-left']"
          >
            Subtitle here
          </p>
          <hidden point="smDown">
            <div class="illustration">
              <img src="../../static/images/movie/faq.png" alt="illustration" />
            </div>
          </hidden>
        </v-col>
        <v-col md="6" cols="12" class="pa-6">
          <div class="accordion">
            <v-expansion-panels
              v-model="panel"
              active-class="expanded"
            >
              <slot/>
            </v-expansion-panels>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Hidden from '../Hidden'
  import Title from './Title'
  import BlockLayout from "../../layout-horizontal/BlockLayout";
  export default {
    name: "FaqLayout",
    extends: BlockLayout,
    data() {
      return {
        panel: 0
      }
    },
    mounted() {
      this.loaded = true;
      this.type = this.blockType === 'Videos' ? 'root_video': 'root';
    },
    components: {
      Hidden,
      'title-main': Title
    },
    computed: {
      isMobile() {
        const smDown = ['mdDown', 'smDown', 'xsDown']
        return smDown.indexOf(this.$mq) > -1
      },
      isTablet() {
        const smDown = ['mdDown', 'smDown', 'xsDown']
        return smDown.indexOf(this.$mq) > -1
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles';
  @import './faq-layout-style';
</style>